import styled from 'styled-components';
import { Icon } from '../../icon/Icon';

interface SurveyRadioInputWithIconProps {
  iconName: 'JobFarmer' | 'JobCompany' | 'JobCommon';
  title: string;
  label?: string;
  isActive: boolean;
  onClick?: () => void;
}

export const SurveyRadioInputWithIcon = ({
  iconName,
  title,
  label,
  isActive,
  onClick,
}: SurveyRadioInputWithIconProps) => {
  return (
    <Container isActive={isActive} onClick={onClick}>
      <IconSection>
        <Icon name={iconName} width={48} height={48} />
      </IconSection>

      <InputTextContainer>
        {label && <InputLabel>{label}</InputLabel>}
        <InputTitle>{title}</InputTitle>
      </InputTextContainer>
    </Container>
  );
};

const Container = styled.div<{ isActive: boolean }>`
  width: 100%;
  height: 150px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  padding: 24px;

  gap: var(--radius-large, 16px);

  border-radius: var(--radius-medium, 8px);
  border: ${(props) => (props.isActive ? '1px solid #196EFF' : '1px solid #f2f2f7')};
  background: ${(props) => (props.isActive ? '#E1FAFF' : '#f2f2f7')};

  cursor: pointer;
`;

const IconSection = styled.div`
  display: flex;
`;

const InputTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const InputLabel = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Small/s-regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 10.2px */
`;

const InputTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* System/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 11.9px */
`;
